import React from "react";

import style from "./CatDivider.module.css";
import catSvg from "../../images/cat.svg";

const CatDivider = () => (
  <div className={style.root}>
    <img className={style.cat} alt="cat" width={40} height={40} src={catSvg} />
  </div>
);
export default CatDivider;



// WEBPACK FOOTER //
// ./src/components/common/CatDivider.js